import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { PipeModule } from "src/app/pipes/pipe.module";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { BenefitsComponent } from "./benefits.component";
import { BenefitsRoutingModule } from "./benefits-routing.module";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    HeaderModule,
    SidebarModule,
    NgxUiLoaderModule,
    PipeModule,
    NgbPopoverModule,
    BenefitsRoutingModule
  ],
  declarations: [
    BenefitsComponent
  ]
})
export class BenefitsModule { }
